import React from 'react'
import { Spinner } from '@shopify/polaris'

const ReportCalendarLoader = ({ minHeight = 200 }) => (
	<div
		className='reporting-calendar-loader'
		style={{ minHeight }}
		role='status'
		aria-live='polite'
		aria-label='Loading'
	>
		<Spinner size='small' />
	</div>
)

export default ReportCalendarLoader
